import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import '../styles/navbar.scss';

function Navbar({ onDropdownToggle }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMFWDropdownOpen, setMFWDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const dropdownRef = useRef(null);
  const mfwDropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMouseEnterPortfolio = () => {
    if (!isMobile) {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeavePortfolio = () => {
    if (!isMobile) {
      setIsDropdownOpen(false);
    }
  };

  const handleMouseEnterEvents = () => {
    if (!isMobile) {
      setMFWDropdownOpen(true);
    }
  };

  const handleMouseLeaveEvents = () => {
    if (!isMobile) {
      setMFWDropdownOpen(false);
    }
  };

  const handlePortfolioClick = () => {
    if (isMobile) {
      setIsDropdownOpen(!isDropdownOpen);
      setMFWDropdownOpen(false); // Close Events dropdown when Portfolio is opened
    }
  };

  const handleEventsClick = () => {
    if (isMobile) {
      setMFWDropdownOpen(!isMFWDropdownOpen);
      setIsDropdownOpen(false); // Close Portfolio dropdown when Events is opened
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLinkClick = (path, sectionId) => {
    navigate(path);
    setIsDropdownOpen(false);
    setMFWDropdownOpen(false);
    if (onDropdownToggle) {
      onDropdownToggle(false);
    }
    if (sectionId) {
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    }
  };

  const handleClickOutside = useCallback((event) => {
    if (
      dropdownRef.current && !dropdownRef.current.contains(event.target) &&
      mfwDropdownRef.current && !mfwDropdownRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
      setMFWDropdownOpen(false);
      if (onDropdownToggle) {
        onDropdownToggle(false);
      }
    }
  }, [onDropdownToggle]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    if (onDropdownToggle) {
      onDropdownToggle(isDropdownOpen);
    }
  }, [isDropdownOpen, onDropdownToggle]);

  return (
    <nav className="navbar">
      <ul className="navbar__links">
        <li><RouterLink to="/" onClick={() => handleLinkClick('/', 'hero')}>Home</RouterLink></li>

        <li className="navbar__item"
          onMouseEnter={handleMouseEnterPortfolio}
          onMouseLeave={handleMouseLeavePortfolio}
        >
          <span onClick={handlePortfolioClick}>Portfolio</span>
          <ul className={`navbar__dropdown ${isDropdownOpen ? 'show' : 'hide'}`} ref={dropdownRef}>
            <li><RouterLink to="/artists" onClick={() => handleLinkClick('/artists')}>Artists</RouterLink></li>
            <li><RouterLink to="/talent" onClick={() => handleLinkClick('/talent')}>Talent</RouterLink></li>
            <li><RouterLink to="/magazine" onClick={() => handleLinkClick('/magazine')}>Magazine</RouterLink></li>
            <li><RouterLink to="/campaign" onClick={() => handleLinkClick('/campaign')}>Campaign</RouterLink></li>
          </ul>
        </li>

        <li className="navbar__item"
          onMouseEnter={handleMouseEnterEvents}
          onMouseLeave={handleMouseLeaveEvents}
        >
          <span onClick={handleEventsClick}>Events</span>
          <ul
            className={`navbar__dropdown ${isMFWDropdownOpen ? 'show' : ''}`}
            ref={mfwDropdownRef}
          >
           <li className="navbar__itemDropdown">
           <RouterLink to="/redcarpet" onClick={() => handleLinkClick('/redcarpet')}>Red Carpet
           </RouterLink>
                <RouterLink to="/mfwhome" onClick={() => handleLinkClick('/mfwhome')}>
                Fashion Week
                </RouterLink>
            </li>
          </ul>
        </li>

        <li className="navbar__item"><RouterLink to="/contact" onClick={() => handleLinkClick('/contact')}>Contact</RouterLink></li>
        
        <li className="navbar__item"><RouterLink to="/press" onClick={() => handleLinkClick('/press')}>Press</RouterLink></li>
      </ul>
    </nav>
  );
}

export default Navbar;
